import React, {useState} from "react";
import Menu from "../../../../../components/layout/menu/index";
import UserDataStep from "../../../../../components/forms/createFormScreen/userDataStep";
import { useNavigate, useParams } from "react-router-dom";
import EditFormScreen from "../../../../../components/forms/editFormScreenSurvey";

const CategoryTabs = ({ categories, activeTab, onTabChange, savedFormData, surveyId }) => {
  const isEnvioDisabled = false;

  return (
    <div className="flex overflow-y-auto">
      {categories.map((category, index) => {
        let isDisabled = false;
        
        if (category === "Envío") {
          isDisabled = isEnvioDisabled;
        } 

        return (
        <button
          key={index}
            className={`py-[17px] px-8 border-b-[3px] rounded-tl-xl rounded-tr-xl border-blue font-itcmedium text-base md:text-lg ${
              activeTab === category
                ? 'bg-blue text-white'
                : isDisabled
                ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                : 'text-blue bg-white hover:bg-blue-50'
            }`}
            onClick={() => {
              if (!isDisabled) {
                onTabChange(category);
              }
            }}
            disabled={isDisabled}
        >
          {category}
        </button>
        );

      })}
    </div>
  );
};

export default function EditSurvey() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const navigate = useNavigate();
  const { surveyId } = useParams();

  const [activeCategoryTab, setActiveCategoryTab] = useState("Preguntas");
  const criteria = ["Preguntas", "Envío"];

  const [savedFormData, setSavedFormData] = useState(null);

  const handleFormSaved = (formData) => {
    setSavedFormData(formData);
    
  };

  const handleFormSent = () => {
    navigate("/encuestas");
  };

  const handleBackToSurveys = () => {
    navigate("/encuestas");
  };

  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
        <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} bg-[#F7F8F9] w-full z-50 min-h-screen`}>
            <div className="sm:pt-8 pt-5 pb-10 sm:px-[3%] px-[5%] flex flex-col gap-4">
                <CategoryTabs 
                    categories={criteria} 
                    activeTab={activeCategoryTab}
                    onTabChange={setActiveCategoryTab}
                    savedFormData={savedFormData} 
                    surveyId={surveyId}
                />

                {activeCategoryTab === "Preguntas" && (
                    <EditFormScreen 
                        surveyId={surveyId}
                        onBack={handleBackToSurveys}
                        onFormSaved={handleFormSaved} 
                    />
                )}

                {activeCategoryTab === "Envío" && (
                    <>
                        <UserDataStep
                          savedFormData={savedFormData}
                          surveyId={surveyId}
                          onBack={() => {
                            setActiveCategoryTab("Preguntas");
                          }}
                          onFormSent={handleFormSent}
                          mode= "edit"
                        />
                    
                    </>
                )}
            </div>
        </div>
    </div>
  );
}